import { render, staticRenderFns } from "./person-baseinfo-form.vue?vue&type=template&id=458f98db&"
import script from "./person-baseinfo-form.vue?vue&type=script&lang=js&"
export * from "./person-baseinfo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports